import { z } from 'zod';

export const appEnvSchema = z.object({
  namespace: z.string(),
  segmentWriteKey: z.string(),
  launchDarklyClientSideId: z.string(),
  apiBaseUrl: z.string(),
  fimApiLocalBaseUrl: z.string().optional(),
  auth0ClientId: z.string(),
  auth0Domain: z.string(),
  nexusRedirectUri: z.string(),
  defaultApiAudience: z.string(),
  muiProLicenseId: z
    .string()
    .default(
      'fed3e794c60408bcf66e7485006ab20cTz0xMjE4NDcsRT0xNzk0NzAwNzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=',
    ),
  portalsBaseUrl: z.string().optional(),
  ddRumAppId: z.string().optional(),
  ddRumClientToken: z.string().optional(),
  ddEnv: z.string().optional(),
  amplitudeApiKey: z.string().optional(),
  slackClientId: z.string().optional(),
});

export const getEnv = (): z.output<typeof appEnvSchema> => {
  return appEnvSchema.parse(window.env);
};
